/* Connect existing report controls and store products to the personal collection. */
(function (global) {
  'use strict';
  var statuses = ['owned', 'want', 'for_sale', 'for_trade', 'incoming', 'sold', 'gifted', 'lost'];
  function safeURL(value) {
    if (!value) return '';
    try { var url = new URL(String(value), 'https://munclemikes.com'); return url.protocol === 'https:' ? url.href : ''; } catch (_) { return ''; }
  }
  function safeImage(value) {
    var url = safeURL(value);
    try { return new URL(url).hostname === 'cdn.shopify.com' ? url : ''; } catch (_) { return ''; }
  }
  function price(value) {
    if (value == null || String(value).trim() === '') return null;
    var number = Number(value);
    if (!Number.isFinite(number) || number < 0) throw new Error('Enter a valid non-negative price.');
    return number;
  }
  function fromLegacy(entry) {
    var quantity = Number(entry.quantity == null ? 1 : entry.quantity);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 9999) throw new Error('Enter a whole quantity between 1 and 9999.');
    return { title: String(entry.title || 'Unidentified collectible'), url: safeURL(entry.url),
      catalogId: String(entry.catalogId || entry.canonicalId || entry.canonical_id || ''),
      status: statuses.indexOf(entry.status) >= 0 ? entry.status : 'owned', quantity: quantity,
      condition: String(entry.condition || 'not_graded'), packaging: String(entry.packaging || 'unknown'),
      purchasePrice: price(entry.purchase_price), purchaseDate: String(entry.purchase_date || ''),
      acquisitionSource: String(entry.acquisition_source || ''), storageLocation: String(entry.storage_location || ''),
      askingPrice: price(entry.asking_price), notes: String(entry.notes || ''), favorite: Boolean(entry.favorite),
      manufacturer: String(entry.manufacturer || entry.brand || ''), casting: String(entry.casting || entry.model || ''),
      releaseYear: String(entry.releaseYear || entry.release_year || ''), series: String(entry.series || entry.productLine || entry.product_line || ''),
      toyNumber: String(entry.toyNumber || entry.toy_number || entry.partNumber || entry.part_number || ''),
      collectorNumber: String(entry.collectorNumber || entry.collector_number || ''), bodyColor: String(entry.bodyColor || entry.body_color || entry.color || ''),
      wheelType: String(entry.wheelType || entry.wheel_type || entry.feature || ''), baseMarkings: String(entry.baseMarkings || entry.base_markings || entry.base || ''),
      scale: String(entry.scale || ''), listIds: [] };
  }
  function fromProduct(product, values) {
    var record = fromLegacy(Object.assign({}, values, { title: product.title, url: product.url }));
    record.catalogId = String(product.catalogId || product.canonicalId || product.canonical_id || '');
    record.imageUrl = safeImage(product.image);
    // Vendor is a store field; it is not necessarily the item's manufacturer.
    // Only an explicit catalog relationship is carried through; titles, URLs and vendors
    // never establish an exact release identity.
    return record;
  }
  function productForVariant(product, variantId, variantTitle, variantImage) {
    var identity = Object.assign({}, product), id = String(variantId || '').trim();
    if (!/^[1-9][0-9]*$/.test(id)) return identity;
    var url = safeURL(product.url);
    if (!url) return identity;
    var parsed = new URL(url); parsed.searchParams.set('variant', id); identity.url = parsed.href;
    if (variantTitle && variantTitle !== 'Default Title') identity.title = product.title + ' · ' + variantTitle;
    if (safeImage(variantImage)) identity.image = safeImage(variantImage);
    return identity;
  }
  function sameStoreItem(first, second) {
    try {
      var a = new URL(safeURL(first)), b = new URL(safeURL(second));
      return a.origin === b.origin && a.pathname === b.pathname && a.searchParams.get('variant') === b.searchParams.get('variant');
    } catch (_) { return false; }
  }
  function observedProduct(root, product) {
    // Search only the enclosing product surface, never a recommendation or a different product form.
    var scope = root.closest('[data-mm-product-root], [data-mm-product], .shopify-section');
    if (!scope) return Object.assign({}, product);
    var field = scope.querySelector('.mm-product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    var id = field && String(field.value || '').trim();
    if (!id || !/^[1-9][0-9]*$/.test(id)) return Object.assign({}, product);
    var reference = root.querySelector('[data-mm-engine-variant-id="' + id + '"]');
    // Only known variants of this snippet's own product are eligible.
    if (!reference) return Object.assign({}, product);
    return productForVariant(product, id, reference.dataset.mmEngineVariantTitle, reference.dataset.mmEngineVariantImage);
  }
  function localeManagerURL(routeRoot) {
    var prefix = String(routeRoot || '/');
    if (!/^\/(?:[a-zA-Z0-9_-]+\/)*[a-zA-Z0-9_-]*\/?$/.test(prefix)) prefix = '/';
    return prefix.replace(/\/$/, '') + '/pages/collection-manager';
  }
  function unchanged(snapshot, current) {
    if (!snapshot || !current || JSON.stringify(snapshot) !== JSON.stringify(current)) throw new Error('This entry changed while you were editing. Close and reopen the form to review the latest details. Your other edits were preserved.');
  }
  function editRecord(previous, incoming, snapshot, fields) {
    if (!previous) return incoming;
    unchanged(snapshot, previous);
    var result = Object.assign({}, previous);
    fields.forEach(function (name) { result[name] = incoming[name]; });
    return result;
  }
  async function authorizeAddition(_provider, _existing) { return true; }
  function boot() {
    var engine = global.MMCollectorEngine;
    if (!engine || !global.document || global.__mmCollectorAddBridgeReady) return;
    global.__mmCollectorAddBridgeReady = true;
    var doc = global.document;
    var reportFields = ['status','quantity','purchasePrice','purchaseDate','condition','packaging','askingPrice','acquisitionSource','storageLocation','notes','favorite'];
    var reportNames = { purchasePrice:'purchase_price', purchaseDate:'purchase_date', askingPrice:'asking_price', acquisitionSource:'acquisition_source', storageLocation:'storage_location' };
    var managerURL = localeManagerURL(global.Shopify && global.Shopify.routes && global.Shopify.routes.root);
    function ownerAccess() {
      var state = engine.getState ? engine.getState() : {}, owner = state.cloudMeta && state.cloudMeta.scopeHash;
      if (!owner) return true;
      var provider = global.MMCollectorMembership, member = provider && provider.getState ? provider.getState() : null;
      return !!member && member.accountVerified === true && member.ownerScopeHash === owner;
    }
    function assertOwnerAccess() {
      if (global.MMCollectorEngine !== engine || !ownerAccess()) throw new Error('Sign in with the account that owns this collection to see its private items and lists.');
    }
    function readRecords() { assertOwnerAccess(); return engine.getRecords(); }
    function pendingAccount() {
      var provider = global.MMCollectorMembership, member = provider && provider.getState ? provider.getState() : null;
      return { provider: provider, owner: member && member.ownerScopeHash };
    }
    function currentAccount(captured, existing) {
      assertOwnerAccess();
      if (global.MMCollectorMembership !== captured.provider) throw new Error('The member account changed during the check. Review this selection and check membership again.');
      var member = captured.provider && captured.provider.getState ? captured.provider.getState() : null;
      if (member && captured.owner && member.ownerScopeHash !== captured.owner) throw new Error('The member account changed during the check. Review this selection and check membership again.');
    }
    function announce(name, detail) { global.dispatchEvent(new CustomEvent(name, { detail: detail })); }
    function fieldValue(form, name) { var field = form.elements.namedItem(name); return field ? field.value : ''; }
    function selectedList(form) { return fieldValue(form, 'mm_engine_list'); }
    function message(form, value) {
      var output = form.querySelector('[data-mm-engine-add-status], [data-mmcr-form-status]');
      if (!output) { output = doc.createElement('p'); output.setAttribute('data-mm-engine-add-status', ''); output.setAttribute('role', 'status'); output.setAttribute('aria-live', 'polite'); form.appendChild(output); }
      output.textContent = value;
    }
    function listSelect(form) {
      var select = form.querySelector('[name="mm_engine_list"]');
      if (!select) {
        var label = doc.createElement('label'); label.textContent = 'Add to a personal list';
        select = doc.createElement('select'); select.name = 'mm_engine_list'; label.appendChild(select); form.appendChild(label);
      }
      var current = select.value; select.replaceChildren();
      var empty = doc.createElement('option'); empty.value = ''; empty.textContent = 'No additional list'; select.appendChild(empty);
      if (ownerAccess()) engine.getLists().forEach(function (list) { var option = doc.createElement('option'); option.value = list.listId; option.textContent = list.name; select.appendChild(option); });
      select.value = ownerAccess() ? current : '';
    }
    function setField(form, name, value) {
      var field = form.elements.namedItem(name); if (!field) return;
      if (field.type === 'checkbox') { field.checked = Boolean(value); return; }
      value = value == null ? '' : String(value);
      if (name === 'purchase_date' && field.type === 'date') {
        field.dataset.mmEngineOriginalDate = value;
        value = /^\d{4}-\d{2}-\d{2}/.test(value) ? value.slice(0, 10) : value;
        field.dataset.mmEngineRenderedDate = value;
      }
      if (field.tagName === 'SELECT' && !Array.from(field.options).some(function (option) { return option.value === value; }) && value) {
        var option = doc.createElement('option'); option.value = value; option.textContent = value; field.appendChild(option);
      }
      field.value = value;
    }
    function fillPersonal(form, record, fields) { fields.forEach(function (name) { setField(form, reportNames[name] || name, record[name]); }); }
    function recordLabel(record, index) {
      return (typeof index === 'number' ? 'Update copy ' + (index + 1) + ': ' : 'Update saved copy: ') + record.status.replace(/_/g, ' ') + ' · ' + record.condition + ' · ' + record.packaging + (record.storageLocation ? ' · ' + record.storageLocation : '') + (record.purchaseDate ? ' · acquired ' + record.purchaseDate : '');
    }
    function recordChoices(select, records, chooseFirst) {
      select.replaceChildren();
      var option = doc.createElement('option'); option.value = ''; option.textContent = 'Add a separate copy / new entry'; select.appendChild(option);
      records.forEach(function (record, index) { var choice = doc.createElement('option'); choice.value = record.recordId; choice.textContent = recordLabel(record, index); select.appendChild(choice); });
      if (chooseFirst && records.length) select.value = records[0].recordId;
    }
    function managerLink(form) {
      var link = doc.createElement('a'); link.href = managerURL; link.textContent = 'Manage all copies and personal lists'; form.appendChild(link);
    }
    function reportIdentity(form) {
      var root = form.closest('[data-mmcr-readable]') || doc.querySelector('[data-mm-collector-tools]');
      if (!root) return null;
      return { handle: root.dataset.reportHandle || root.dataset.recordHandle || '', title: root.dataset.reportTitle || root.dataset.recordTitle || doc.title,
        url: root.dataset.reportUrl || root.dataset.recordUrl || global.location.href };
    }
    function formEntry(form, identity) {
      var entry = Object.assign({}, identity);
      ['status','quantity','purchase_price','purchase_date','condition','packaging','asking_price','acquisition_source','storage_location','notes'].forEach(function (name) {
        entry[name] = fieldValue(form, name);
        var field = form.elements.namedItem(name);
        if (name === 'purchase_date' && field && field.dataset.mmEngineRenderedDate === entry[name]) entry[name] = field.dataset.mmEngineOriginalDate;
      });
      var favorite = form.elements.namedItem('favorite'); entry.favorite = Boolean(favorite && favorite.checked); return entry;
    }
    function selectionState(form, identity, mode) {
      return JSON.stringify({ entry: formEntry(form, identity), copy: mode.value, list: selectedList(form) });
    }
    function currentSelection(revision, capturedRevision, state, capturedState) {
      if (revision !== capturedRevision || state !== capturedState) throw new Error('Your selection changed while membership was being checked. Review the form and save again. No entry was added or changed.');
    }
    function enhanceReport(form) {
      if (form.dataset.mmEngineEnhanced) return;
      form.dataset.mmEngineEnhanced = 'true'; listSelect(form);
      var statusField = form.elements.namedItem('status');
      var statusNames = { owned: 'Owned', want: 'Want list', for_sale: 'For sale', for_trade: 'For trade', incoming: 'Incoming', sold: 'Sold', gifted: 'Gifted', lost: 'Lost' };
      if (statusField && statusField.tagName === 'SELECT') statuses.forEach(function (value) {
        if (!Array.from(statusField.options).some(function (option) { return option.value === value; })) {
          var option = doc.createElement('option'); option.value = value; option.textContent = statusNames[value]; statusField.appendChild(option);
        }
      });
      ['acquisition_source','storage_location','notes'].forEach(function (name) { var field = form.elements.namedItem(name); if (field) field.maxLength = name === 'notes' ? 5000 : 200; });
      var label = doc.createElement('label'), mode = doc.createElement('select'), snapshot = null, opener = null, revision = 0;
      label.textContent = 'Save as'; mode.name = 'mm_engine_report_record'; label.appendChild(mode); form.appendChild(label); managerLink(form);
      var dialog = form.closest('dialog');
      var owner = form.closest('[data-mmcr-readable]') || doc.querySelector('[data-mm-collector-tools]');
      if (owner) {
        opener = owner.querySelector('[data-mmcr-open], [data-mm-collection-open]');
        owner.querySelectorAll('a[href*="/pages/my-collector-workspace"], a[href*="/pages/collector-portfolio"]').forEach(function (link, index) {
          if (index === 0) { link.href = managerURL; link.textContent = 'My Collection'; } else link.hidden = true;
        });
      }
      function prepare() {
        revision++;
        try {
          var identity = reportIdentity(form); if (!identity || !identity.handle) return;
          assertOwnerAccess(); form.hidden = false;
          engine.migrateLegacy();
          var records = readRecords().filter(function (record) { return sameStoreItem(record.url, identity.url); });
          var primary = engine.getLegacyRecordId('mm_collector_collection_v2', identity.handle);
          records.sort(function (a, b) { return a.recordId === primary ? -1 : b.recordId === primary ? 1 : 0; });
          listSelect(form); recordChoices(mode, records, true); snapshot = records.length ? records[0] : null;
          if (snapshot) fillPersonal(form, snapshot, reportFields);
          message(form, records.length ? 'Choose an existing copy to update, or add a separate copy. Your earlier entries are preserved.' : 'This will create a new private collection entry.');
        } catch (error) { snapshot = null; fillPersonal(form, fromLegacy({status:'owned',quantity:1}), reportFields); recordChoices(mode, [], false); listSelect(form); message(form, error.message || 'The collection could not be loaded.'); }
      }
      // Legacy opener fills/reset its form first; canonical details take precedence afterward.
      if (opener) opener.addEventListener('click', function () { queueMicrotask(prepare); });
      if (dialog && typeof global.MutationObserver === 'function') {
        new global.MutationObserver(function () { if (dialog.hasAttribute('open')) prepare(); }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
      }
      if (dialog) dialog.addEventListener('close', function () { revision++; if (opener) opener.focus(); });
      mode.addEventListener('change', function () {
        revision++;
        if (!ownerAccess()) { prepare(); return; }
        snapshot = mode.value ? readRecords().find(function (record) { return record.recordId === mode.value; }) : null;
        if (snapshot) fillPersonal(form, snapshot, reportFields);
        else fillPersonal(form, fromLegacy({ status: fieldValue(form, 'status'), quantity: 1 }), reportFields);
        message(form, snapshot ? 'Updating this existing copy. Other copies are unchanged.' : 'A separate copy will be added. Edit its condition, cost and location before saving.');
      });
      prepare();
      form.addEventListener('submit', async function (event) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (!form.reportValidity() || form.dataset.mmMemberPending) return;
        form.dataset.mmMemberPending = 'true';
        try {
          var identity = reportIdentity(form); if (!identity || !identity.handle) throw new Error('This report does not have a collection identity.');
          assertOwnerAccess(); var capturedAccount = pendingAccount();
          var capturedRevision = revision, capturedState = selectionState(form, identity, mode), capturedSnapshot = snapshot;
          var record = fromLegacy(formEntry(form, identity));
          var previous = mode.value ? readRecords().find(function (item) { return item.recordId === mode.value; }) : null;
          if (mode.value && !previous) throw new Error('This copy no longer exists. Close and reopen the form to choose a new entry.');
          record = editRecord(previous, record, snapshot, reportFields);
          await authorizeAddition(capturedAccount.provider, previous);
          currentAccount(capturedAccount, previous);
          currentSelection(revision, capturedRevision, selectionState(form, reportIdentity(form), mode), capturedState);
          if (previous) unchanged(capturedSnapshot, readRecords().find(function (entry) { return entry.recordId === previous.recordId; }));
          var listId = selectedList(form); if (listId && record.listIds.indexOf(listId) < 0) record.listIds = record.listIds.concat(listId);
          var saved = engine.upsert(record); snapshot = saved;
          if (!previous) { var option = doc.createElement('option'); option.value = saved.recordId; option.textContent = recordLabel(saved); mode.appendChild(option); mode.value = saved.recordId; }
          var success = previous ? 'Your collection copy was updated.' : 'A separate copy was saved. Your earlier entries are unchanged.';
          message(form, success);
          var status = owner && owner.querySelector('[data-mmcr-status], [data-mm-tool-status]'); if (status) status.textContent = success;
          announce('mm:collector-record-added', { recordId: saved.recordId, source: 'report', mode: previous ? 'update' : 'new' });
          if (dialog) { if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open'); }
          if (opener) opener.focus();
        } catch (error) {
          if (!ownerAccess()) { revision++; snapshot = null; fillPersonal(form, fromLegacy({status:'owned',quantity:1}), reportFields); recordChoices(mode, [], false); listSelect(form); if (dialog && dialog.hasAttribute('open')) dialog.close(); }
          message(form, error.message || 'The copy could not be saved.');
        }
        finally { delete form.dataset.mmMemberPending; }
      }, true);
      global.addEventListener('mm:membership-change', function () {
        if (ownerAccess()) return;
        revision++; snapshot = null; fillPersonal(form, fromLegacy({status:'owned',quantity:1}), reportFields); recordChoices(mode, [], false); listSelect(form);
        if (dialog && dialog.hasAttribute('open')) dialog.close();
        var status = owner && owner.querySelector('[data-mmcr-status], [data-mm-tool-status]'); if (status) status.textContent = 'This collection belongs to another account.';
        message(form, 'Private collection details are hidden. Check membership with the account that owns this device collection.');
      });
    }
    global.addEventListener('mm:collection-record-saved', function (event) {
      var entry = event.detail; if (!entry || !entry.handle) return;
      var form = Array.from(doc.querySelectorAll('[data-mmcr-form], [data-mm-collection-form]')).find(function (candidate) { var identity = reportIdentity(candidate); return identity && identity.handle === entry.handle; });
      try {
        assertOwnerAccess();
        var result = engine.migrateLegacy();
        var id = engine.getLegacyRecordId('mm_collector_collection_v2', entry.handle);
        var conflict = result.conflicts && result.conflicts.some(function (item) { return item.recordId === id; });
        if (conflict) {
          if (form) queueMicrotask(function () { message(form, 'Your earlier workspace edits were preserved. Open My Collection to review the report update.'); });
          announce('mm:collector-add-conflict', { source: 'report', handle: entry.handle });
          return;
        }
        if (form && selectedList(form) && readRecords().some(function (record) { return record.recordId === id; })) engine.addToList(id, selectedList(form));
        announce('mm:collector-record-added', { recordId: id, source: 'report', mode: result.updated ? 'update' : 'new' });
      } catch (error) { if (form) queueMicrotask(function () { message(form, 'The original browser entry is saved. My Collection could not import it: ' + error.message); }); }
    });
    function enhanceProduct(root) {
      if (root.dataset.mmEngineEnhanced) return;
      root.dataset.mmEngineEnhanced = 'true';
      var isGuide = root.hasAttribute('data-mm-engine-guide');
      if (isGuide && doc.querySelector('[data-mmcr-form], [data-mm-collection-form]')) { root.hidden = true; return; }
      if (isGuide) {
        var hero = doc.querySelector('#mm-casting-guide .mc-hero-copy, .mm-casting-editorial .mc-hero-copy, .mm-variation-editorial .mc-hero-copy');
        if (hero && !hero.contains(root)) hero.appendChild(root);
      }
      var form = root.querySelector('[data-mm-engine-product-form], [data-mm-engine-item-form]');
      if (!form) return;
      var mode = form.querySelector('[name="mm_engine_record"]');
      var product = { title: root.dataset.productTitle || root.dataset.guideTitle, url: root.dataset.productUrl || root.dataset.guideUrl, image: root.dataset.productImage || '',
        catalogId: root.dataset.catalogId || root.dataset.canonicalId || '' };
      var editableFields = isGuide ? reportFields : ['status','quantity','condition','packaging','purchasePrice'];
      var snapshot = null, trigger = null, revision = 0;
      var summary = root.querySelector('[data-mm-engine-selected-product], [data-mm-engine-selected-item]');
      function selectedIdentity() { return isGuide ? product : observedProduct(root, product); }
      function open(status, button) {
        revision++;
        var selectedProduct = selectedIdentity();
        trigger = button; snapshot = null;
        form.reset(); listSelect(form);
        if (!ownerAccess()) { recordChoices(mode, [], false); form.hidden = true; message(form, 'Private collection details are hidden. Check membership with the account that owns this device collection.'); return; }
        var records = readRecords().filter(function (record) { return sameStoreItem(record.url, selectedProduct.url); });
        recordChoices(mode, records, false);
        var preferred = records.find(function (record) { return record.status === status; });
        if (preferred) { mode.value = preferred.recordId; snapshot = preferred; fillPersonal(form, snapshot, editableFields); }
        form.elements.namedItem('status').value = status; form.hidden = false;
        if (summary) summary.textContent = (isGuide ? 'Guide reference: ' : 'Selected store item: ') + selectedProduct.title;
        message(form, preferred ? 'An existing copy is selected. Choose Add a separate copy to keep another specimen.' : records.length ? 'Other entries exist for this item. This will add a separate entry unless you choose an existing copy to update.' : 'This will create a new private collection entry.'); mode.focus();
      }
      mode.addEventListener('change', function () {
        revision++;
        if (!ownerAccess()) { snapshot = null; fillPersonal(form, fromLegacy({status:'owned',quantity:1}), editableFields); recordChoices(mode, [], false); listSelect(form); form.hidden = true; return; }
        if (!mode.value) {
          snapshot = null; fillPersonal(form, fromLegacy({ status: fieldValue(form, 'status'), quantity: 1 }), editableFields);
          message(form, 'Adding a separate copy. Enter its own condition and purchase cost.'); return;
        }
        var record = readRecords().find(function (item) { return item.recordId === mode.value; }); if (!record) return;
        snapshot = record; fillPersonal(form, record, editableFields);
        message(form, 'Updating this copy. Other personal details and other copies are unchanged.');
      });
      root.querySelectorAll('[data-mm-engine-product-open], [data-mm-engine-item-open]').forEach(function (button) { button.addEventListener('click', function () { open(button.dataset.mmEngineProductOpen || button.dataset.mmEngineItemOpen, button); }); button.hidden = false; });
      function close() { revision++; form.hidden = true; if (trigger) trigger.focus(); }
      root.querySelector('[data-mm-engine-product-cancel], [data-mm-engine-item-cancel]').addEventListener('click', close);
      form.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); close(); } });
      var productScope = !isGuide && root.closest('[data-mm-product-root], [data-mm-product], .shopify-section');
      if (productScope) productScope.addEventListener('change', function (event) {
        if (form.hidden || !event.target || event.target.name !== 'id') return;
        var currentProduct = observedProduct(root, product);
        if (summary) summary.textContent = 'Selected store item: ' + currentProduct.title;
        if (mode.value) message(form, 'The store selection changed. Close and reopen this form to choose a copy for that variant.');
      });
      form.addEventListener('submit', async function (event) {
        event.preventDefault(); if (!form.reportValidity() || form.dataset.mmMemberPending) return;
        form.dataset.mmMemberPending = 'true';
        try {
          var selectedProduct = selectedIdentity();
          assertOwnerAccess(); var capturedAccount = pendingAccount();
          var capturedRevision = revision, capturedState = selectionState(form, selectedProduct, mode), capturedSnapshot = snapshot;
          var record = fromProduct(selectedProduct, formEntry(form, {}));
          var previous = mode.value && readRecords().find(function (item) { return item.recordId === mode.value; });
          if (mode.value && !previous) throw new Error('The selected entry no longer exists. Choose a new entry.');
          if (previous && !sameStoreItem(previous.url, selectedProduct.url)) throw new Error('The selected product variant changed. Close this form and open I Own This or I Want This again. Your existing entry is unchanged.');
          if (previous) {
            // Keep personal fields absent from this small product editor.
            record = editRecord(previous, record, snapshot, editableFields);
          }
          await authorizeAddition(capturedAccount.provider, previous);
          currentAccount(capturedAccount, previous);
          currentSelection(revision, capturedRevision, selectionState(form, selectedIdentity(), mode), capturedState);
          if (previous) unchanged(capturedSnapshot, readRecords().find(function (entry) { return entry.recordId === previous.recordId; }));
          var listId = selectedList(form); if (listId && record.listIds.indexOf(listId) < 0) record.listIds = record.listIds.concat(listId);
          var saved = engine.upsert(record); snapshot = saved;
          message(form, previous ? 'Collection entry updated in this browser.' : 'Added to your collection in this browser.');
          // Select the just-saved copy so a second Save updates it instead of making an accidental duplicate.
          if (!previous) { var option = doc.createElement('option'); option.value = saved.recordId; option.textContent = 'Update this saved entry'; mode.appendChild(option); mode.value = saved.recordId; }
          announce('mm:collector-record-added', { recordId: saved.recordId, source: isGuide ? 'guide' : 'product', mode: previous ? 'update' : 'new' });
        } catch (error) {
          if (!ownerAccess()) { revision++; snapshot = null; fillPersonal(form, fromLegacy({status:'owned',quantity:1}), editableFields); recordChoices(mode, [], false); listSelect(form); form.hidden = true; }
          message(form, error.message || 'The collection entry could not be saved.');
        }
        finally { delete form.dataset.mmMemberPending; }
      });
      global.addEventListener('mm:membership-change', function () {
        if (ownerAccess()) return;
        revision++; snapshot = null; fillPersonal(form, fromLegacy({status:'owned',quantity:1}), editableFields); recordChoices(mode, [], false); listSelect(form); form.hidden = true;
        message(form, 'Private collection details are hidden. Check membership with the account that owns this device collection.');
      });
    }
    function scan(scope) {
      if (scope.matches && scope.matches('[data-mmcr-form], [data-mm-collection-form]')) enhanceReport(scope);
      if (scope.matches && scope.matches('[data-mm-engine-product], [data-mm-engine-guide]')) enhanceProduct(scope);
      scope.querySelectorAll('[data-mmcr-form], [data-mm-collection-form]').forEach(enhanceReport);
      scope.querySelectorAll('[data-mm-engine-product], [data-mm-engine-guide]').forEach(enhanceProduct);
    }
    scan(doc);
    doc.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    if (typeof global.MutationObserver === 'function') new global.MutationObserver(function (changes) {
      changes.forEach(function (change) { change.addedNodes.forEach(function (node) { if (node.nodeType === 1 && node.querySelectorAll) scan(node); }); });
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }
  if (typeof module === 'object' && module.exports) module.exports = { fromLegacy: fromLegacy, fromProduct: fromProduct, productForVariant: productForVariant, observedProduct: observedProduct, sameStoreItem: sameStoreItem, localeManagerURL: localeManagerURL, editRecord: editRecord, safeURL: safeURL, safeImage: safeImage, authorizeAddition: authorizeAddition, boot: boot };
  if (global.document) {
    if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);

